import mapDataToComponents from "../actions/mapDataToComponents";
import _ from 'lodash';

export function formatPData(data, state) {

  let useRelativeTarget = state.user.client && state.user.client.settings && state.user.client.settings.useRelativeTarget;
  const manualTarget = state.user.client && state.user.client.settings && state.user.client.settings.manualTarget;

  const setIndexAsTarget = false;

  if (!data.rlv.target || (setIndexAsTarget && !isNaN(data.rlv.index))) {
    data.rlv.target = parseFloat(data.rlv.index).toFixed(2);
  }

  if (useRelativeTarget) {
    data.rlv.target = parseFloat((data.rlv.score * 1.1)).toFixed(2);
  }

  if (!isNaN(manualTarget)) {
    data.rlv.target = manualTarget;
  }

  const _data = mapDataToComponents(data);
  const map = {price:'prc',proposal:'prp',people:'ppl',preference:'prf',product:'prd',promotion:'prm',place:'plc',total:'rlv'};
  _data.brand = data.brand;
  _data.variables = _data.variables.filter(x => x != null);
  _data.variables.forEach(v => {
    if (v && data[map[v.id]] && data[map[v.id]].weight) {
      v.weight = parseFloat(Math.abs(data[map[v.id]].weight*100)).toFixed(2);
    }
  });

  if (data.rlv && data.rlv.index) {
    _data.index = data.rlv.index;
  }

  // Aggregate sentimentdata
  let sentimentData = [];
  _data.variables.forEach(v => {
    if (v.components && v.components.sentimentWordCloud) {
      sentimentData.push(...v.components.sentimentWordCloud.words);
    }
  });
  _data.sentimentData = sentimentData;

  // Add potential
  _data.variables.forEach(v => {
    let potential = Math.abs((v.target) - (v.nscore));
    if (v.nscore > v.target) {
      potential = 0;
    }
    v.potential = potential;
  });

  // Add Impact (previously adjustedWeight)
  let sum = 0;
  _data.variables.forEach(v => {
    if (v.id !== "total" && v.weight) {
      sum += parseFloat(v.weight);
    }
  });
  let factor = 100/sum;
  _data.variables.forEach(v => {
    v.impact = parseFloat(v.weight * factor).toFixed(1);
  })

  // Add correlations
  const telescope = state.data.telescope
  _data.variables.forEach(v => {
    let Ps = {};

    _data.variables.forEach(compareV => {

      if (v.id !== "total" && compareV.id !== "total" && v.id !== compareV.id) {
        const input = {};
        input[v.apiId] = 1;

        let baseInput = {};
        let deltaInput = {};
        baseInput[v.apiId] = 0;
        deltaInput[v.apiId] = 1;

        if (v.apiId) {
          const basePrediction = telescope.predict(baseInput);
          const deltaPrediction = telescope.predict(deltaInput);
          const baseCoeff = basePrediction[compareV.apiId];
          const deltaCoeff = deltaPrediction[compareV.apiId];
          const coeff = deltaCoeff - baseCoeff;

          Ps[compareV.apiId] = parseFloat(coeff).toFixed(2)
        }
      }
    })
    v.correlations = Ps
  })


  // GET SUBSCRIPTIONS
  const rawData = state.user && state.user.client && state.user.client.rawData;
  let results = {};

  if (rawData) {
    const dataArray = _.filter(rawData, function(row, i) {
      return row[0].value === "newSubscriptions";
    })
    results = {}
    _.each(dataArray, function(y) {
      let year = y[1].value;
      results[year] = {};
      _.each(y, function(month, i) {
        const skipCols = 2;
        if (i>=skipCols && month.value && results[year]) {
          results[year][i-1] = month.value;
        }
      })
    });
    _data.newSubscriptions = results;
  }

  return _data
}



// WEBPACK FOOTER //
// ./src/helpers/dataHelpers.js